<template>
  <div class="signIn" style="background:#F5F5F8;">
    <van-nav-bar
      :title="$t('m.qd_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content" style="position: relative;">
      <!-- <div class="signIn_btn">
        <div class="discolor" @click="signIn">
          <img style="width: 100%;height: 100%;" :src="signInTitle=='立即签到'?img1:img2" alt="">
        </div>
      </div>
      <div class="sigIn_list_title" style="margin-top:70px;margin-bottom:10px;">
        <img style="height: 15px;width: auto;margin:0 auto;display:block;" src="../../assets/images/qianlie.png" alt="">
      </div> -->
      <!-- 签到列表 -->
      <div style="position: absolute;left:25px;top:80px;color:#fff;">
        <!-- <div style="font-size:16px;font-weight:bold;">{{$t('m.qd_span01')}}</div> -->
        <!-- <div style="font-size:13px;font-weight:bold;margin-top:5px;">{{$t('m.qd_span02')}}</div> -->
      </div>
      <div style="background:#fff;border-radius:10px;padding:20px 12px;">
        <section class="sign-guide">
          <div class="guide-heading">
            <div>
              <small>DAILY CHECK-IN</small>
              <h2>签到说明与奖励</h2>
            </div>
            <span>每日1次</span>
          </div>
          <div class="reward-panel">
            <div class="reward-main">
              <span>今日签到奖励</span>
              <strong>{{ formatReward(todayReward) }} <em>USD</em></strong>
            </div>
            <div class="reward-account">
              <span>发放账户</span>
              <strong>{{ rewardAccount }}</strong>
            </div>
          </div>
          <ul class="sign-rules">
            <li>每天仅可签到1次，签到成功后奖励立即到账。</li>
            <li>签到金额按当前会员等级对应的后台奖励配置发放。</li>
            <li v-if="!hasProject && maxWithoutProject > 0">
              暂未购买产品时，累计最多可签到 {{ maxWithoutProject }} 次；当前已签到 {{ signedCount }} 次。
            </li>
            <li v-else-if="hasProject">已购买产品的用户可按活动规则每日参与签到。</li>
            <li v-else>未购买产品时的累计签到次数以后台当前活动规则为准。</li>
          </ul>
          <div class="level-reward-rules">
            <div class="level-rule-title">
              <strong>各等级每日签到奖励</strong>
              <span>按签到时所在等级发放</span>
            </div>
            <div class="level-reward-grid">
              <div v-for="level in rewardLevels" :key="level.id || level.level">
                <span>{{ level.name || (Number(level.level) === 0 ? "普通会员" : `VIP${level.level}`) }}</span>
                <strong>{{ formatReward(level.sign_reward || level.sign) }} <em>USD</em></strong>
              </div>
            </div>
          </div>
        </section>
        <div
          style="display:flex;align-items:center;color:#000;justify-content: center;"
        >
          <span>{{ $t("m.qd_span4") }}</span>
          <!-- <div style="font-size:16px;font-weight:600;">今日签到得2 USD</div>
           <div style="display:flex;align-items:center;font-size:12px;color:#333;">
             签到提醒
             <van-switch style="margin-left:8px;" v-model="checked" active-color="#FF4600" inactive-color="#EBEBEB" size="14px" />
           </div> -->
        </div>
        <div
          class="discolor"
          @click="signIn"
          :style="{
            background:
              signInTitle == $t('m.qd_span3') ? 'var(--bg-color)' : '#CCCCCC'
          }"
          style="text-align:center; width: 70%;margin:0 auto;line-height:50px;border-radius:30px;font-weight:bold;color:#fff;font-size:15px;margin-top:22px;"
        >
          <!--          {{ $t("m.qd_span3") }}-->
          {{ signInTitle }}
        </div>
        <!-- <div style="display:flex;align-items:center;color:#999;justify-content: space-between;font-size:11px; width: 85%;margin:0 auto;margin-top:20px;">
          <div><img src="../../assets/images/new/liwu.png" style="width: 10px;height: 10px;margin-right:3px;" alt="">
          <span>连续签到30天，获惊喜礼包</span>
          </div>
          <div @click="jifens()">我的积分{{jifen}}<van-icon name="arrow" size="11" color="#999999" /></div>
        </div> -->
      </div>
      <div
        style="background:#fff;border-radius:10px;padding:15px 12px ;margin-top:10px;display:flex;align-items:center;"
      >
        <div
          style="width: 40px;height: 40px;background:#FFECE7;border-radius:50%;"
        >
          <img
            src="../../assets/images/new/yaoqing.png"
            style="width: 30px;height: 30px;margin:5px;"
            alt=""
          />
        </div>
        <span
          style="color:#000;font-weight:bold;font-size:14px;flex:1;margin-left:8px;"
          >{{ $t("m.qd_span6") }}</span
        >
        <div
          @click="yaoqing()"
          style="background:var(--bg-color);text-align:center; width: 80px;margin:0 auto;line-height:30px;border-radius:20px;color:#fff;font-size:12px;"
        >
          立即邀请
        </div>
      </div>
      <div
        class="signIn_list"
        style="background:#FFF6F0;margin-top:10px;padding:15px 12px;border-radius:10px;"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            style="font-size:16px;font-weight:600;margin-bottom:10px;color:var(--bg-color);"
          >
            {{ $t("m.qd_span8") }}
          </div>
          <div class="item" v-for="(item, index) in signInList" :key="index">
            <div
              style="border:1px solid #FF8A3E;width: 40px;height: 40px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#fff;margin-right:12px;"
            >
              <img
                src="../../assets/images/new/renwus.png"
                style="width: 20px;height: 20px;"
                alt=""
              />
            </div>
            <div class="divs">
              <span style="fint-size:14px;font-weight:bold;color:#444;">
                {{ $t("m.qd_span9") }}
              </span>
              <span>{{ item.created_at }}</span>
            </div>
            <div
              class="divs1"
              style="font-size:20px;font-weight:bold;color:#FF8A3E;"
            >
              <span>&#43;</span>
              <span>{{ item.integral }}</span>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import request from "@utils/request";
import { getMyUserInfo } from "@api/user";
export default {
  name: "",
  data() {
    return {
      checked: true,
      img1: require("../../assets/images/ljqd.png"),
      img2: require("../../assets/images/yiqian.png"),
      signInTitle: "立即签到",
      signInList: [],
      loading: false,
      finished: false,
      refreshing: false,
      jifen: 0,
      userInfo: {},
      page: 0,
      todayReward: 0,
      rewardAccount: "可建仓余额",
      hasProject: false,
      maxWithoutProject: 0,
      signedCount: 0,
      rewardLevels: []
    };
  },
  created() {
    let that = this;
    this.loadRewardLevels();
    setTimeout(function() {
      getMyUserInfo().then(res => {
        let userInfo = res.data.data;
        if (userInfo.is_auth != 1) {
          that.$dialog.message("请先完成实名认证");
          that.$router.push({ name: "memmber_business" });
        }
      });
    }, 500);
    setTimeout(function() {
      that.status();
    }, 1000);
    setTimeout(function() {
      request
        .post("/user/user/index", {}, { login: true })
        .then(res => {
          that.jifen = res.data.data.integral;
        })
        .catch(err => {
          that.$dialog.error(err.response.data.msg);
        });
    }, 2000);
  },
  methods: {
    loadRewardLevels() {
      request
        .get("/user/level/list", {}, { login: false })
        .then(res => {
          const rows = res && res.data && res.data.data;
          this.rewardLevels = Array.isArray(rows) ? rows : [];
        })
        .catch(() => {
          this.rewardLevels = [];
        });
    },
    yaoqing() {
      this.$router.push({
        path: "/invitation"
      });
    },
    jifens() {
      this.$router.push({
        path: "/JfList"
      });
    },
    async signIn() {
      if (this.signInTitle === "今日已签到") {
        return;
      }
      this.signInTitle = "今日已签到";
      request
        .get("/shop/sign/add", {}, { login: true })
        .then(res => {
          console.log("签到");
          console.log(res);
          const reward = Number(res.data && res.data.data ? res.data.data.reward : 0);
          const message = reward > 0
            ? `签到成功，已到账 ${reward.toFixed(2)} USD`
            : "签到成功";
          this.$dialog.success(message);
          this.$router.go(0);
        })
        .catch(err => {
          this.signInTitle = "立即签到";
          this.$dialog.error(err.response.data.msg);
        });
    },
    async status() {
      request
        .get("/shop/sign/status", {}, { login: true })
        .then(res => {
          console.log("签到");
          console.log(res);
          if (res.data.data.status == 1) {
            this.signInTitle = "今日已签到";
          }
          this.todayReward = Number(res.data.data.reward || 0);
          this.rewardAccount = res.data.data.reward_account || "可建仓余额";
          this.hasProject = Number(res.data.data.has_project || 0) === 1;
          this.maxWithoutProject = Number(
            res.data.data.max_without_project || 0
          );
          this.signedCount = Number(res.data.data.signed_count || 0);
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;
      request
        .get("/shop/sign/log", { page: _this.page }, { login: true })
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.length; i++) {
            this.signInList.push({
              id: res.data.data[i]["id"],
              created_at: res.data.data[i]["created_at"],
              title: res.data.data[i]["id"],
              integral: res.data.data[i]["integral"]
            });
          }
          this.loading = false;
          if (res.data.data.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.error(err.response.data.msg);
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    formatReward(value) {
      return Number(value || 0).toFixed(2);
    },
    onRefresh() {
      this.page = 0;
      this.list = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      this.loading = true;
      // this.onLoad();
    }
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
@import "../../assets/css/signIn.less";
html,
body {
  background: #fff !important;
}
.discolor:active {
  opacity: 0.3 !important;
}

.sign-guide {
  margin-bottom: 19px;
  padding: 16px;
  text-align: left;
  background: linear-gradient(145deg, #f3f7ff, #fffaf0);
  border: 1px solid #e5ebf7;
  border-radius: 16px;
}

.guide-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.guide-heading small {
  color: #7e93be;
  font-size: 9px;
  letter-spacing: 1.4px;
}

.guide-heading h2 {
  margin: 4px 0 0;
  color: #283957;
  font-size: 17px;
}

.guide-heading > span {
  padding: 5px 9px;
  color: #fff;
  font-size: 10px;
  background: #557ed0;
  border-radius: 999px;
}

.reward-panel {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 9px;
  margin-top: 13px;
}

.reward-main,
.reward-account {
  padding: 12px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 15px rgba(67, 91, 137, 0.08);
}

.reward-panel span {
  display: block;
  color: #8c94a3;
  font-size: 10px;
}

.reward-main strong {
  display: block;
  margin-top: 5px;
  color: #df7b32;
  font-size: 22px;
}

.reward-main em {
  font-size: 10px;
  font-style: normal;
}

.reward-account strong {
  display: block;
  margin-top: 9px;
  color: #4268b2;
  font-size: 13px;
}

.sign-rules {
  margin: 13px 0 0;
  padding: 0;
  list-style: none;
}

.sign-rules li {
  position: relative;
  margin-top: 6px;
  padding-left: 13px;
  color: #697386;
  font-size: 10px;
  font-weight: 400;
  line-height: 1.55;
}

.sign-rules li::before {
  position: absolute;
  top: 6px;
  left: 0;
  width: 5px;
  height: 5px;
  content: "";
  background: #e0a34a;
  border-radius: 50%;
}
.level-reward-rules { margin-top: 15px; padding-top: 13px; border-top: 1px solid rgba(90,112,150,.13); }
.level-rule-title { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.level-rule-title strong { color: #32415b; font-size: 12px; }
.level-rule-title span { color: #8b94a4; font-size: 9px; }
.level-reward-grid { display: grid; grid-template-columns: repeat(2,minmax(0,1fr)); gap: 7px; margin-top: 10px; }
.level-reward-grid > div { display: flex; padding: 8px 9px; align-items: center; justify-content: space-between; background: rgba(255,255,255,.88); border: 1px solid #e8edf5; border-radius: 9px; }
.level-reward-grid span { color: #667287; font-size: 10px; }
.level-reward-grid strong { color: #b06d1d; font-size: 11px; }
.level-reward-grid em { font-size: 8px; font-style: normal; }
</style>

